export function header() {
  addClassToHeader();
  overlayClick();
  cartOpenButton();
}

export function headerMobile() {
  reArrangeProfile();
  languageSettingsAsIcon();
}

export function headerDesktop() {
  languageSettingsAsIcon();
}

function addClassToHeader() {
  const $header = $('#Header');
  if (!$header.length) return;

  if ($header.hasClass('wl-custom-header')) {
    return;
  }

  $header.addClass('wl-custom-header');
}

function reArrangeProfile() {
  let element = $();

  if ($('#UserLoginFlyout').length) {
    element = $('#UserLoginFlyout').detach();
  } else if ($('#UserLoginLink').length) {
    element = $('#UserLoginLink').detach();
  }

  // Check if wrapper already exists
  if (!$('#OpenLoginWrapper').length) {
    $('#OpenCartWrapper').before(`<div id="OpenLoginWrapper"></div>`);
  }

  if (element.length) {
    $('#OpenLoginWrapper').empty().append(element);
  }
  $('#UsernameLink').hide();
}

function overlayClick() {
  $('#OffcanvasMenuOverlay')
    .off('click.wl')
    .on('click.wl', function () {
      closeSettingsPanel();
      $('body').removeClass('offcanvas-menu-open offcanvas-menu-open-user-toolbar');
    });
}

function cartOpenButton() {
  $('#OpenCartWrapper')
    .off('click.wl')
    .on('click.wl', function () {
      $('body').addClass('offcanvas-cart-open');
    });
}

function languageSettingsAsIcon() {
  if (!$('#OpenSettingsWrapper').length) {
    const settingsWrapper = `
      <div id="OpenSettingsWrapper" class="header-item-wrapper">
        <a href="#" id="OpenSettings" class="header-item">
          <img src="/images/site/earth-filled.svg" alt="Inställningar" class="header-icon" />
        </a>
      </div>
    `;
    $('#OpenCartWrapper').after(settingsWrapper);
  }

  // Byt ikon på stängknappen
  $('#MenuToolbarPanelLocationClose > i').removeClass('fw-icon-left').addClass('fw-icon-cancel');
  $('#Header').off('click.wlSettings', '#OpenSettings').on('click.wlSettings', '#OpenSettings', openSettingsPanel);
  $('#Menu').off('click.wlSettings', '#MenuToolbarPanelLocationClose').on('click.wlSettings', '#MenuToolbarPanelLocationClose', closeSettingsPanel);
  $('#menu-overlay').off('click.wlSettings').on('click.wlSettings', closeSettingsPanel);
}

function openSettingsPanel(e) {
  e.preventDefault();

  if ($('#OpenMenu').is(':visible')) {
    $('#OpenMenu').trigger('click');
    $('body').addClass('wl-settings-open');
    return;
  }
  $('body').addClass('wl-settings-open');

  $('#Menu').addClass('settingsToolbarOpen').removeClass('submenu-open');
  $('#menu-overlay').addClass('open');
}

function closeSettingsPanel(e) {
  if (e) {
    e.preventDefault();
  }

  if (!$('body').hasClass('offcanvas-menu-open')) {
    $('body').removeClass('wl-settings-open');
    return;
  }

  $('#CloseMenu').trigger('click');

  setTimeout(() => { // Stäng menyn och ta sen bort klassen så vi inte flashar menyinnehållet.
    $('body').removeClass('wl-settings-open');
  }, 400);
}
